import StoreRow from './StoreRow/StoreRow'
import StoresTableSkeleton from './StoresTableSkeleton/StoresTableSkeleton'
import TableHeader from './TableHeader/TableHeader'
import * as Styles from './styles'

const StoresTable = ({ loading, stores, onSort, orderBy }) => {
  if (loading) return <StoresTableSkeleton />

  return (
    <Styles.Container>
      <Styles.Table>
        <TableHeader onSort={onSort} orderBy={orderBy} />
        <tbody>
          {stores?.map((store, index) => (
            <StoreRow key={store?.store_name} store={store} index={index + 1} />
          ))}
        </tbody>
      </Styles.Table>
    </Styles.Container>
  )
}

export default StoresTable
